import React, { Fragment, useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import {
  faAsterisk,
  faPlus,
  faSave,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import GetStudentService from "../../../../services/SchoolIT/GetStudentService";
import { Modal, ModalBody } from "reactstrap";
import AppHeader from "../../../../Layout/AppHeader";
import AppSidebar from "../../../../Layout/AppSidebar";
import swal from "sweetalert";

const goalFieldOptionArray = [
  { id: "course", field_name: "completed course requirement" },
  { id: "AND", field_name: "completed all of the following" },
  { id: "OR", field_name: "completed one of the following" },
];

const AddNewModal = ({ isOpen, closeHandler, data }) => {
  const [input, setInput] = useState("");

  return (
    <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler} centered>
        <ModalBody>
          <h5 style={{ padding: "15px 16px 0 16px", textAlign: "center" }}>
            {data.title}
          </h5>
          <div style={{ position: "relative", padding: "10px" }}>
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
              type="text"
              placeholder="Field Name"
              className="require-input-name"
            />
          </div>
        </ModalBody>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "5px 0 30px 0",
          }}
        >
          <button
            disabled={!input}
            style={{ padding: "5px 20px", margin: "0 30px", fontSize: "20px" }}
            className={!input ? "disabled-modal-button" : "save-modal-button"}
            onClick={() => data.save(input)}
          >
            <FontAwesomeIcon icon={faSave} style={{ margin: "0 10px" }} />
            Save
          </button>
          <button
            style={{
              padding: "5px 20px",
              margin: "0 30px",
              fontSize: "20px",
            }}
            className="cancel-modal-button"
            onClick={closeHandler}
          >
            <FontAwesomeIcon icon={faTimes} style={{ margin: "0 6px" }} />
            Cancel
          </button>
        </div>
      </Modal>
    </Fragment>
  );
};

const ViewGoalMap = () => {
  let history = useHistory();
  let location = useLocation();
  const [goalName, setGoalName] = useState();
  const [goalDescription, setGoalDescription] = useState();
  const [goalId, setGoalId] = useState(location?.pathname?.split("/").pop());
  const [goalData, setGoalData] = useState();
  const [parentCount, setParentCount] = useState(0);
  const [parentCountArray, setParentCountArray] = useState([]);
  const [marginForParent, setMarginForParent] = useState("");
  const [courseCriteria, setCourseCriteria] = useState([]);
  const [gpaLessThanValue, setGpaLessThanValue] = useState();
  const [addNewCourseModal, setAddNewCourseModal] = useState(false);
  const [addNewGoalModal, setAddNewGoalModal] = useState(false);
  const [user, setUser] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [fieldOperators, setFieldOperators] = useState([]);
  const [goalFieldOption, setGoalFieldOption] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const gpaRef = useRef();
  const fieldOptionRef = useRef();
  const courseRef = useRef();
  const arithemeticOperatorRef = useRef();

  const getGoalDetail = () => {
    GetStudentService.getGoalDetail(goalId)
      .then((data) => {
        console.log("data from the goal service", data);
        setGoalData(data?.data);
        setCourseCriteria(Object.values(data?.data?.green));
        setGoalName(data?.data?.goal_name);
        setGoalDescription(data?.data?.goal_description);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const updateGoalMap = () => {
    // let arr = Object.values(goalData?.green);
    for (let i = 0; i < courseCriteria.length; i++) {
      courseCriteria[i].green_simple_exp = courseCriteria[i].simple_exp;
      delete courseCriteria[i].simple_exp;
    }
    let obj = {
      goal_description: goalDescription,
      goal_id: goalId,
      goal_name: goalName,
      green: [null, ...courseCriteria],
      school_id: user?.school_id,
      subgoal_id: Object.values(goalData?.subgoal_id),
    };
    GetStudentService.createGoalMap(obj)
      .then((data) => {
        if (data?.msg) {
          swal({
            text: `Selected Literal goalfield ${data["msg"]}`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        } else {
          history.push("/school_it/ccplus");
        }
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: `The given Goal name already exists`,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  const saveNewCourse = (name) => {
    let obj = {
      name: name,
      school_id: user?.school_id,
    };
    GetStudentService.saveNewCourse(obj)
      .then((data) => {
        console.log(data);
        setAddNewCourseModal(false);
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: error.response.data.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };
  const saveNewGoalField = (name) => {
    let obj = {
      field_name: name,
      school_id: user?.school_id,
    };
    GetStudentService.saveNewGoalField(obj)
      .then((data) => {
        console.log(data);
        setAddNewGoalModal(false);
      })
      .catch((error) => {
        if (error.response.data) {
          swal({
            text: error.response.data.message,
            icon: "warning",
            dangerMode: true,
            buttons: {
              cancel: true,
            },
            closeOnClickOutside: false,
          });
        }
      });
  };

  const getGoalField = () => {
    GetStudentService.goalFieldForCreateGoal(user?.school_id)
      .then((data) => {
        console.log(data);
        setGoalFieldOption([...data?.data?.objects, ...goalFieldOptionArray]);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const getFieldOperators = () => {
    GetStudentService.listOfOperators()
      .then((data) => {
        console.log("data from the operators", data);
        setFieldOperators(data?.data?.objects);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  
  const getCourseList = () => {
    GetStudentService.listOfCourse(user?.school_id)
      .then((data) => {
        console.log("data from the course list", data);
        setCourseListData(data.data.objects);
      })
      .catch((error) => {
        console.log("error from the service", error);
      });
  };

  const AddNewCriteria = (parentValue) => {
    console.log("first");
    if (parentValue) {
      setParentCount(parentCount + 1);
    }
    let array = [];
    let data = {
      field_name: "",
      operator: "",
      value: "",
      course_req: "",
      green_simple_exp: "",
      parent: parentValue ? parentCountArray : [],
      level: parentValue ? parentCountArray.length : 0,
      margin: parentValue ? `${marginForParent}px` : "margin",
      have_not: "",
    };
    array.push(data);
    setCourseCriteria([...courseCriteria, ...array]);
  };

  const removeCourseCriteria = (index) => {
    courseCriteria.splice(index, 1);
    setCourseCriteria([...courseCriteria]);
  };

  const handlehaveOrHaveNotChange = (index, e) => {
    courseCriteria[index].have_not = e.target.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleFieldOption = (index) => {
    courseCriteria[index].field_name = fieldOptionRef.current.value;
    console.log(courseCriteria);
    setCourseCriteria([...courseCriteria]);
  };

  const handleArithemeticOperatorChange = (index) => {
    courseCriteria[index].operator = arithemeticOperatorRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleCourseChange = (index) => {
    courseCriteria[index].course_req = courseRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  const handleGPAChange = (index) => {
    courseCriteria[index].value = gpaRef.current.value;
    setCourseCriteria([...courseCriteria]);
  };

  useEffect(() => {
    getGoalDetail();
    getGoalField();
    getFieldOperators();
    getCourseList();
  }, []);
  return (
    <Fragment>
    <AppHeader />
    <div className="app-main">
      <AppSidebar />
      <div className="app-main__outer">
      <div style={{ padding: "15px", fontSize: "14px" }}>
        <div className="flex" style={{ justifyContent: "space-between" }}>
          <p style={{ fontSize: "24px" }} className="no-margin-bottom">
            Create New Goal
          </p>
          <div>
            <button
              className="create-maintain-group-button"
              onClick={() => setAddNewCourseModal(true)}
            >
              Add New Required Course Set
            </button>
            <button
              style={{ margin: "0 5px" }}
              onClick={() => setAddNewGoalModal(true)}
              className="create-maintain-group-button"
            >
              Add New Goal Field
            </button>
            <button
              onClick={() => history.push("/school_it/ccplus")}
              className="create-maintain-group-button"
            >
              Back
            </button>
          </div>
        </div>
        <div className="requiredname-input-container">
          <div style={{ textAlign: "right" }}>
            <p className="no-margin-bottom requirement-text">Goal Name</p>
          </div>
          <div style={{ position: "relative" }}>
            <input
              value={goalName}
              onChange={(e) => setGoalName(e.target.value)}
              style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
              type="text"
              className="require-input-name"
            />
            <FontAwesomeIcon
              style={{ position: "absolute", top: "10px", right: "10px" }}
              icon={faAsterisk}
              color="red"
            />
          </div>
        </div>
        <div className="requiredname-input-container">
          <div style={{ textAlign: "right" }}>
            <p className="no-margin-bottom requirement-text">
              Goal Description
            </p>
          </div>
          <div style={{ position: "relative" }}>
            <textarea
              value={goalDescription}
              onChange={(e) => setGoalDescription(e.target.value)}
              style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
              type="text"
              className="require-input-name"
              rows="5"
            />
            <FontAwesomeIcon
              style={{ position: "absolute", top: "10px", right: "10px" }}
              icon={faAsterisk}
              color="red"
            />
          </div>
          <div
            style={{ marginTop: "-15px" }}
            className="requiredname-input-container"
          >
            <div></div>
            <div>
              <input
                //value={goalName}
                //onChange={(e) => setGoalName(e.target.value)}
                style={{ width: "100%", padding: "5px", borderRadius: "5px" }}
                type="text"
                className="require-input-name"
                placeholder="Type a goal name to add"
              />
            </div>
          </div>
        </div>
        <div className="create-a-new-set">
          <div
            style={{
              border: "1px solid #ccc",
              borderBottom: "none",
              padding: "8px",
            }}
          >
            Create a set of criteria for green
          </div>
          <div style={{ borderBottom: "1px solid #ccc" }}></div>
        </div>
        {/* <div>
          {courseCriteria?.length > 0 && courseCriteria
              .slice(0, 1)
              .map((item) => {
                return (
                  <div
                    style={{
                      margin: "15px 0",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                    }}
                  >
                    <button
                      style={{
                        background: "#d9534f",
                        opacity: goalData?.is_global ? "0.65": '1',
                        border: "none",
                        borderRadius: "5px",
                        padding: "8px 15px",
                      }}
                    >
                      <FontAwesomeIcon icon={faTimes} color="white" />
                    </button>
                    <p className="no-margin-bottom">Student must</p>
                    <select
                      disabled={goalData?.is_global}
                      style={{ width: "100px" }}
                      value={item?.have_not}
                    >
                      <option value="True">have</option>
                      <option value="False">have not</option>
                    </select>
                    <select
                      disabled={goalData?.is_global}
                      style={{ width: "75px" }}
                    >
                      <option value={item?.display_fieldname} selected>
                        {item?.display_fieldname}
                      </option>
                    </select>
                    <select
                      disabled={goalData?.is_global}
                      style={{ width: "75px" }}
                    >
                      <option value={item?.display_operator} selected>
                        {item?.display_operator}
                      </option>
                    </select>
                    <input
                      type="text"
                      style={{ marginLeft: "30px" }}
                      value={item?.value}
                    />
                  </div>
                );
              })}
        </div> */}
        <div>
          {courseCriteria?.length > 0 &&
            courseCriteria.map((item, index) => {
              console.log(item);
              return (
                <div
                  style={{
                    margin: "15px 0",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                  }}
                >
                  <button
                    style={{
                      background: "#d9534f",
                      opacity: goalData?.is_global ? "0.65" : "1",
                      border: "none",
                      borderRadius: "5px",
                      padding: "8px 15px",
                    }}
                    onClick={() => removeCourseCriteria(index)}
                  >
                    <FontAwesomeIcon icon={faTimes} color="white" />
                  </button>
                  &nbsp;
                  <p className="no-margin-bottom">Student must</p>&nbsp;
                  <select
                    disabled={goalData?.is_global}
                    value={item?.have_not}
                    style={{ width: "100px" }}
                    // ref={haveOrHaveNotRef}
                    onChange={(e) => handlehaveOrHaveNotChange(index, e)}
                  >
                    <option value="" disabled selected>
                      --Select option---
                    </option>
                    <option value="True">have</option>
                    <option value="False">have not</option>
                  </select>
                  <select
                    ref={fieldOptionRef}
                    value={item?.field_name}
                    onChange={() => handleFieldOption(index)}
                    disabled={goalData?.is_global}
                    style={{ width: "220px" }}
                  >
                    <option value="" selected disabled>
                      --Select---
                    </option>
                    {goalFieldOption?.map((item, index) => (
                      <option value={item?.id}>{item?.field_name}</option>
                    ))}
                  </select>
                  {item.field_name === "1" && (
                    <div>
                      <select
                        ref={arithemeticOperatorRef}
                        onChange={() => handleArithemeticOperatorChange(index)}
                      >
                        <option disabled selected value={null}>
                          --Select Operator--
                        </option>
                        {fieldOperators?.map((item, index) => (
                          <option value={parseInt(item?.id)}>
                            {item?.operator}
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        ref={gpaRef}
                        onChange={() => handleGPAChange(index)}
                      />
                    </div>
                  )}
                   {item.field_name === "course" && (
                  <select
                    ref={courseRef}
                    value={item?.course_req}
                    disabled={goalData?.is_global}
                    style={{ width: "380px" }}
                    onChange={() => handleCourseChange(index)}
                  >
                    <option>--Select Course--</option>
                    {courseListData?.map((item, index) => (
                      <option value={item?.course?.id}>
                        {item?.course?.name}
                      </option>
                    ))}
                  </select>
                )}
                  
                </div>
              );
            })}
        </div>
        <div style={{ marginTop: "20px" }}>
          <button
            disabled={goalData?.is_global}
            className={
              goalData?.is_global
                ? "disabled-modal-button"
                : "create-maintain-group-button"
            }
            onClick={() => AddNewCriteria(true)}
          >
            <FontAwesomeIcon icon={faPlus} style={{ margin: "0 5px" }} />
            Add Additional Criteria
          </button>
        </div>
        <div style={{ marginTop: "30px" }}>
          <button className="save-modal-button" onClick={updateGoalMap}>
            <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faSave} />
            Save
          </button>

          <button
            onClick={() => history.push("/school_it/ccplus")}
            className="cancel-modal-button2"
          >
            <FontAwesomeIcon
              style={{ margin: "0 5px" }}
              icon={faTimes}
              color="black"
            />
            Cancel
          </button>
        </div>
        {addNewCourseModal && (
          <AddNewModal
            isOpen={addNewCourseModal}
            closeHandler={() => {
              setAddNewCourseModal(false);
            }}
            data={{ title: "Create Required Course Set", save: saveNewCourse }}
          />
        )}
        {addNewGoalModal && (
          <AddNewModal
            isOpen={addNewGoalModal}
            closeHandler={() => {
              setAddNewGoalModal(false);
            }}
            data={{ title: "New Goal Field", save: saveNewGoalField }}
          />
        )}
      </div>
      </div>
      </div>
    </Fragment>
  );
};
export default ViewGoalMap;
